import React, { useState, useEffect } from "react";
import Recommended from "./Recommended";
import { whoToFollow } from "../../../api/users";
import _ from "lodash";
import { useSelector } from "react-redux";

export default function WhoToFollow(props) {
  const store = useSelector((state) => state);
  const [users, setUsers] = useState(null);
  useEffect(() => {
    fetchWhoToFollow();
  }, [!!store.current_user]);

  const fetchWhoToFollow = () => {
    if(!!store.current_user){
      whoToFollow().then(({ data: { users } }) => setUsers(users));
    }
  };
  return _.isNull(users) || !users.length ? null : (
    <div id="who_to_follow" className="m-4">
      <h2 className="mb-3">Who to Follow</h2>
      {users && users.map((u) => <Recommended key={u.id} user={u} />)}
    </div>
  );
}
